import React from 'react';

const Integrated = () => {
    return (
        <div>
          <section id="page-title" className="page-title page-title-layout10 bg-overlay bg-parallax text-center">
            <div className="bg-img"><img src="assets/images/page-titles/imf.jpg" alt="background" /></div>
            <div className="container">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-8 offset-lg-2">
                  <h1 className="pagetitle__heading">Integrated Facilities Management (IFM)</h1>
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb justify-content-center">
                      <li className="breadcrumb-item"><a href="integrated#">Home</a></li>
                      <li className="breadcrumb-item active" aria-current="page">Integrated Facilities Management</li>
                    </ol>
                  </nav>
                </div>{/* /.col-lg-8 */}
              </div>{/* /.row */}
            </div>{/* /.container */}
          </section>{/* /.page-title */}
          {/* =========================== 
        portfolio Grid 
      ============================= */}
          <section id="blogGrid" className="blog blog-grid">
            <div className="container">
              <div className="row">
                {/* Blog Item #1 */}
                <div className="col-sm-12 col-md-6 col-lg-1">
                </div>{/* /.col-lg-4 */}
                {/* Blog Item #2 */}
                <div className="col-sm-12 col-md-6 col-lg-10">
                  <div className="row heading heading-2 mb-40">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <span className="heading__subtitle">Integrated Facilities Management (IFM)</span>
                    </div>{/* /.col-lg-12 */}
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <h2 className="heading__title">Benefits of Integrated Facilities Management include:</h2>
                    </div>{/* /heading */}
                  </div>
                  <div className="blog-item">
                    <img src="assets/images/ifm.png" alt="blog images" />
                  </div>{/* /.blog-item */}
                </div>{/* /.col-lg-4 */}
                {/* Blog Item #3 */}
                <div className="col-sm-12 col-md-6 col-lg-1">
                </div>{/* /.col-lg-4 */}
              </div>{/* /.row */}
            </div>{/* /.container */}
          </section>
          <section id="portfolioGrid" className="portfolio portfolio-grid">
            <div className="container">
              <div className="row">
                {/* portfolio item #1 */}
                <div className="row heading heading-2 mb-40">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <span className="heading__subtitle">Evermore Management Providing Strategic Direction</span>
                  </div>{/* /.col-lg-12 */}
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <h2 className="heading__title">Total Facilities Management / Service Delivery Management</h2>
                  </div>{/* /heading */}
                </div>
                <div className="col-sm-6 col-md-6 col-lg-4">
                  <div className="portfolio-item">
                    <div className="portfolio__img">
                      <img src="assets/images/case-studies/house-cleaning.jpg" alt="portfolio img" />
                    </div>{/* /.portfolio-img */}
                    <div className="portfolio__content">
                      <h4 className="portfolio__title"><a href="integrated#">Housekeeping Service</a></h4>
                      <div className="divider__line divider__lg" />
                      <p className="portfolio__desc" style={{color: '#000'}}>
                      </p><div className="footer__widget footer__widget-nav">
                        <div className="footer__widget-content">
                          <nav>
                            <ul className="list-unstyled">
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>Cleaning</a></li>
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>Consumables</a></li>
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>Refuse disposal &amp; Recycling</a></li>
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>Floor Mats</a></li>
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>Textiles</a></li>
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>Greenery</a></li>
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>Pest Control</a></li>
                            </ul>
                          </nav>
                        </div>{/* /.footer-widget-content */}
                        <h6 className="footer__widget-title" style={{color: '#000'}}>Facilities management master planning</h6>
                        <h6 className="footer__widget-title" style={{color: '#000'}}>Risk reviews</h6>
                        <h6 className="footer__widget-title" style={{color: '#000'}}>Life cycle modeling</h6>
                      </div>{/* /.col-xl-2 */}
                      <p />
                    </div>{/* /.portfolio-content */}
                  </div>{/* /.portfolio-item */}
                </div>{/* /.col-lg-4 */}
                {/* portfolio item #2 */}
                <div className="col-sm-6 col-md-6 col-lg-4">
                  <div className="portfolio-item">
                    <div className="portfolio__img">
                      <img src="assets/images/case-studies/electrical-maintenance.jpg" alt="portfolio img" />
                    </div>{/* /.portfolio-img */}
                    <div className="portfolio__content">
                      <h4 className="portfolio__title"><a href="integrated#">Technical Maintenance</a></h4>
                      <div className="divider__line divider__lg" />
                      <div className="footer__widget footer__widget-nav">
                        <div className="footer__widget-content">
                          <nav>
                            <ul className="list-unstyled">
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>HVAC</a></li>
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>Electrical Systems</a></li>
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>BAS</a></li>
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>Safety</a></li>
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>Technical Systems</a></li>
                            </ul>
                          </nav>
                        </div>{/* /.footer-widget-content */}
                      </div>{/* /.col-xl-2 */}
                    </div>{/* /.portfolio-content */}
                  </div>{/* /.portfolio-item */}
                </div>{/* /.col-lg-4 */}
                <div className="col-sm-6 col-md-6 col-lg-4">
                  <div className="portfolio-item">
                    <div className="portfolio__img">
                      <img src="assets/images/case-studies/call-care.jpg" alt="portfolio img" />
                    </div>{/* /.portfolio-img */}
                    <div className="portfolio__content">
                      <h4 className="portfolio__title"><a href="integrated#">Other Services Support</a></h4>
                      <div className="divider__line divider__lg" />
                      <div className="footer__widget footer__widget-nav">
                        <div className="footer__widget-content">
                          <nav>
                            <ul className="list-unstyled">
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>All service provision admin Space Management ~ plan/move</a></li>
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>Furniture acquisition/disposal</a></li>
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>Receptionist/security</a></li>
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>Utilities &amp; energy Management</a></li>
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>HSE</a></li>
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>Risk management</a></li>
                            </ul>
                          </nav>
                        </div>{/* /.footer-widget-content */}
                      </div>{/* /.col-xl-2 */}
                    </div>{/* /.portfolio-content */}
                  </div>{/* /.portfolio-item */}
                </div>{/* /.col-lg-4 */}
                <div className="col-sm-6 col-md-6 col-lg-4">
                  <div className="portfolio-item">
                    <div className="portfolio__img">
                      <img src="assets/images/case-studies/planning-with.jpg" alt="portfolio img" />
                    </div>{/* /.portfolio-img */}
                    <div className="portfolio__content">
                      <h4 className="portfolio__title"><a href="integrated#">Project Planning, Management and Supervision</a></h4>
                      <div className="divider__line divider__lg" />
                      <p className="portfolio__desc" style={{color: '#000'}}>
                      </p><div className="footer__widget footer__widget-nav">
                        <div className="footer__widget-content">
                          <nav>
                            <ul className="list-unstyled">
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>Design</a></li>
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>Consultancy Services</a></li>
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>Project Planning and Execution</a></li>
                            </ul>
                          </nav>
                        </div>{/* /.footer-widget-content */}
                      </div>{/* /.col-xl-2 */}
                      <p />
                    </div>{/* /.portfolio-content */}
                  </div>{/* /.portfolio-item */}
                </div>{/* /.col-lg-4 */}
                {/* portfolio item #2 */}
                <div className="col-sm-6 col-md-6 col-lg-4">
                  <div className="portfolio-item">
                    <div className="portfolio__img">
                      <img src="assets/images/case-studies/hospitality.jpg" alt="portfolio img" />
                    </div>{/* /.portfolio-img */}
                    <div className="portfolio__content">
                      <h4 className="portfolio__title"><a href="integrated#">Catering Assurance &amp; Supervision</a></h4>
                      <div className="divider__line divider__lg" />
                      <div className="footer__widget footer__widget-nav">
                        <div className="footer__widget-content">
                          <nav>
                            <ul className="list-unstyled">
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>Supervision of Housekeeping</a></li>
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>HACCP</a></li>
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>Catering and Hospitality Services</a></li>
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>Consumable products</a></li>
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>Receptionist &amp; Front Desk</a></li>
                            </ul>
                          </nav>
                        </div>{/* /.footer-widget-content */}
                      </div>{/* /.col-xl-2 */}
                    </div>{/* /.portfolio-content */}
                  </div>{/* /.portfolio-item */}
                </div>{/* /.col-lg-4 */}
                <div className="col-sm-6 col-md-6 col-lg-4">
                  <div className="portfolio-item">
                    <div className="portfolio__img">
                      <img src="assets/images/case-studies/energy.jpg" alt="portfolio img" />
                    </div>{/* /.portfolio-img */}
                    <div className="portfolio__content">
                      <h4 className="portfolio__title"><a href="integrated#">Utilities Support Services</a></h4>
                      <div className="divider__line divider__lg" />
                      <div className="footer__widget footer__widget-nav">
                        <div className="footer__widget-content">
                          <nav>
                            <ul className="list-unstyled">
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>Energy Management</a></li>
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>Power Generation &amp; Distribution</a></li>
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>Water Supply and Networks</a></li>
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>AGO supply</a></li>
                              <li><a href="integrated#" style={{color: '#000', fontSize: '16px'}}>Cooking Gas</a></li>
                            </ul>
                          </nav>
                        </div>{/* /.footer-widget-content */}
                      </div>{/* /.col-xl-2 */}
                    </div>{/* /.portfolio-content */}
                  </div>{/* /.portfolio-item */}
                </div>{/* /.col-lg-4 */}
                {/* portfolio item #3 */}
                {/* /.col-lg-4 */}
                {/* portfolio item #4 */}
              </div>{/* /.row */}
            </div>{/* /.container */}
          </section>
        </div>
      );
};

export default Integrated;
